export const state = {
  trips: [],
  systemTrip: [],
  trip_income: [
    {
      description: "",
      unit_price: "",
      total: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/state.js